import styled, {css} from 'styled-components'
import FlexItem from 'shared/FlexItem'
export default styled.div`
  position: absolute;
  height: 100%;
  width: 50%;
  right: 0;
  top: 0;
  background: rgba(0,0,0,0);
  z-index: 10;

  cursor: e-resize !important;
`



// WEBPACK FOOTER //
// ./src/components/Next.js